import {
  Paragraph,
  ContentSection,
  SectionHeading,
} from '@vwfs-bronson/bronson-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getLandingPage } from '../../../../services/redux/features/page'

export default function EsignRefused() {
  const { t } = useTranslation()

  const landingPage = useSelector(getLandingPage)

  return (
    <React.Fragment>
      <ContentSection pageWrapSize="small">
        <SectionHeading center level={3}>
          {t('eSign:refused.heading')}
        </SectionHeading>
      </ContentSection>
      <ContentSection pageWrapSize="small">
        <Paragraph>{t('eSign:refused.subtitle')}</Paragraph>
      </ContentSection>
      <ContentSection pageWrapSize="small">
        <div className="u-text-center">
          <a
            className="c-btn"
            href={`${window.location.origin}/${landingPage}`}
          >
            {t('eSign:refused.backToMain')}
          </a>
        </div>
      </ContentSection>
    </React.Fragment>
  )
}
